import React from 'react';
import { Link } from "react-router-dom";
import { Segment, Header, Divider, Button } from "semantic-ui-react";

const Footer = () => (
<Segment textAlign='center' inverted className="Footer">
    <span className="FooterMainHeader">
      خَيْرُكُمْ مَنْ تَعَلَّمَ الْقُرْآنَ وَعَلَّمَهُ    
    </span>
    <Divider fitted hidden/>
    <span className="FooterMainHeaderSub">
      "The best among you are those who learn the Qur'an and teach it."
    </span>
    <Divider />
    <Button basic inverted as={Link} to="/contact" content="Leave us a review or comment here!" />
  <Header inverted>
    Ahl Al Quran
    <Header.Subheader>Join us on Telegram!</Header.Subheader>
    <Header.Subheader><a href="https://t.me/ahlalquranphilly">https://t.me/AhlAlQuranPhilly</a></Header.Subheader>
    <Header.Subheader>AhlAlQuranPhilly@gmail.com</Header.Subheader>
  </Header>
</Segment>
)
export default Footer;